export default __webpack_public_path__ + "static/media/demo1.7980969f.png";